import { Box } from '@chakra-ui/react';
import { Text } from '@web-app/components/Typography/Text';
import { FC } from 'react';

import {
  MEAL_PLAN_STEP_NUMBER,
  MEAL_PLAN_STEP_TITLE,
  MEAL_PLAN_TOTAL_STEPS,
  MealPlanView,
} from './utils';

export interface MealPlanStepHeaderProps {
  step: MealPlanView;
}

export const MealPlanStepHeader: FC<MealPlanStepHeaderProps> = ({ step }) => {
  return (
    <Box pt={9}>
      <Text textType="xs" color="text.muted">
        Step {MEAL_PLAN_STEP_NUMBER[step]}/{MEAL_PLAN_TOTAL_STEPS}
      </Text>
      <Text textType="lg" fontWeight={600}>
        {MEAL_PLAN_STEP_TITLE[step]}
      </Text>
    </Box>
  );
};
